import ApiService from './ApiService'

export default class ProviderService {
    apiService

    constructor(key) {
        this.apiService = new ApiService(process.env.VUE_APP_ENTITLEMENTS_API)
        this.apiService.setApiKey(key)
    }

    async get({ platform, company_uuid, cc, lang }) {
        const request = await this.apiService
            .get(`/${ company_uuid }/providers`, {
                platform,
                country: cc,
                lang,
            })

        return request.data
    }
}
